import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../common/BaseComponent/BaseComponent';

import buttons from '../../common/primitives/Button.scss';
import styles from './ComponentBreadcrumb.scss';
import {_isDesktop, _isTablet} from "../../common/helpers/HelperFunc";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import ButtonArrow from "../../common/primitives/ButtonArrow";
import HelperGoogleAnalytics4 from '../../common/helpers/HelperGoogleAnalytics4';
import {__t} from '../../common/lang/text-resource';

class ComponentBreadcrumb extends BaseComponent {

	hasActive = false;
	cartIsOpen = this.props.cartIsOpen && _isDesktop();
	pathNames = {
		bcr_t_01: __t('Изберете Хостинг'),
		bcr_t_02: __t('Избор на домейн'),
		bcr_t_03: __t('Други услуги'),
		bcr_t_04: __t('Данни за клиент'),
		bcr_t_05: __t('Преглед на поръчка'),
		bcr_t_06: __t('Изберете VPS'),
		bcr_t_07: __t('Други услуги'),
		bcr_t_08: __t('Операционна система'),
		bcr_t_09: __t('Изберете MVPS'),
		bcr_t_10: __t('Специално предложение'),
		bcr_t_20: __t('Специално предложение'),
		bcr_t_11: __t('Изберете нает сървър'),
		bcr_t_12: __t('Изберете магазин'),
		bcr_t_13: __t('Изберете период'),
		bcr_t_14: __t('Изберете услуга'),
		bcr_t_15: __t('GDPR Протект'),
		bcr_t_res_name: __t('Въведете потребителско име'),
	};

	eventConsume(actionName, actionObject) {
		if (actionName === 'ToggleCart') {
			this.cartIsOpen = actionObject.isOpen;
			this.setState(this.state);
		}
		if (actionName === 'LazyLoadingComplete') {
			if (actionObject.componentName === 'ComponentCart') {
				this.isCartOpen = actionObject.componentData.isOpen && _isDesktop();
				this.setState(this.state);
			}
		}
		if (actionName === 'ContextCartUpdate') {
			if (this.isCartOpen && actionObject.countServices === 0) {
				this.isCartOpen = false;
				this.setState(this.state);
			}
		}
		if (actionName === 'ToggleCartDisabledState') {
			const continueButton1 = document.querySelector('#bredcrumbContinueButton1');
			const continueButton2 = document.querySelector('#bredcrumbContinueButton2');
			if (continueButton1) {
				if (actionObject.disable) {
					continueButton1.setAttribute('disabled', 'disabled');
					continueButton2.setAttribute('disabled', 'disabled');
				} else {
					continueButton1.removeAttribute('disabled');
					continueButton2.removeAttribute('disabled');
				}
			}
		}
	}

	continue = () => {

		HelperGoogleAnalytics.TrackContinueButton('Up');
		HelperGoogleAnalytics4.TrackContinueButton('Up');

		if (typeof this.props.continue === 'function') {
			this.props.continue();
		}
	};

	render() {
		const {
			path
		} = this.state.componentData;

		let showContinueButton = true;
		if (this.rootPage().componentName === 'PageCustomerLogin') {
			if (this.rootPage().state.componentData.isLoggedIn === false) {
				showContinueButton = false;
			}
		}

		const breadcrumb = path.map((stepData, index) => {
			  const {isActive, isPassed, url, code} = stepData;
			  let listItem = <li key={index}><span>{index + 1}</span></li>;

			  if (isActive) {
				  this.hasActive = true;
				  const checkoutStep = index + 1;

				  //записваме в сесията стъпката на поръчката.
				  sessionStorage.setItem('checkoutStep', checkoutStep);


				  listItem =
					<li key={index} title={this.pathNames[code]} className={styles.active}>
						<span>{checkoutStep}</span>{this.pathNames[code]}</li>;
			  }

			  if (isPassed) {
				  listItem =
					<li key={index} title={this.pathNames[code]} className={styles.passed}><a
					  href={url}><span>{index + 1}</span></a>
					</li>;
			  }
			  return (listItem);
		  }
		);

		if (path.length === 0 || !this.hasActive) {
			return <div className={styles.empty}/>;
		}
		const hasContinue = typeof this.props.continue === 'function';
		return (
		  <ul
			className={`${styles.container} ${this.cartIsOpen ? styles.cartIsOpen : ''} ${this.props.withoutCart ? styles.withoutCart : ''}`}
			data-layout="text-center">
			  {breadcrumb}
			  {
				  hasContinue && showContinueButton ?
					<li data-test="breadcrumb-continue-button-holder">
						<div data-layout={'hide@md'}>
							<ButtonArrow onClick={this.continue} id={'bredcrumbContinueButton1'}/>
						</div>
						<input
						  className={`${buttons.btnPrimary} ${this.cartIsOpen && _isTablet() ? styles.smallButton : styles.breadCrumbBtn}`}
						  type="button"
						  data-layout={'hide show@md'}
						  onClick={this.continue}
						  id={'bredcrumbContinueButton2'}
						  value={`${this.cartIsOpen && _isTablet() ? __t('Продължи') : __t('Продължи с поръчката')}`}/>
					</li> : null
			  }
		  </ul>
		);
	}
}

ComponentBreadcrumb.propTypes = {
	continue: PropTypes.func,
	withoutCart: PropTypes.bool,
	cartIsOpen: PropTypes.bool
};


// React Context binding
ComponentBreadcrumb.contextType = ContextDataStore;

export default ComponentBreadcrumb;
